import { createFileRoute } from "@tanstack/react-router";

import McpServersAdmin from "@/components/McpServersAdmin";

// Generated to match `src/app/admin/mcp-servers/page.tsx`. The route is a passthrough: the console
// component owns everything, and `admin/route.tsx` owns the shell and the gate.
export const Route = createFileRoute("/admin/mcp-servers")({
  component: McpServersAdmin,
});
